import { render, staticRenderFns } from "./statements.vue?vue&type=template&id=660671b0"
import script from "./statements.vue?vue&type=script&lang=js"
export * from "./statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports